// Entitycore
// Models
import { MruItem } from "../../mru/MruItem";
/** Class to handle serialization/deserialization for Mru item data */ export class MruSerializationHandler {
    /** serialize to IMruItemPersistedResource */ toSerializable(key, value) {
        return value.forPersistence();
    }
    /** build IMruItem from IMruItemPersistedResource */ fromSerializable(key, serializableValue) {
        return MruItem.fromResource(serializableValue);
    }
}
